// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const PlatformSignetIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="PlatformSignetIcon" ref={forwardedRef} {...props}>
      <path d="m13.832 15.716-.053.035z" />
      <path d="M14.601 3.789a720 720 0 0 1-4.327-1.165s-.38-.127-.777-.032S6.682 3.53 6.682 3.53l.004-.002L6.682 3.53C5.828 3.825 6.055 5.234 6.055 5.234l.203 2.243L5.1 7.051a.855.855 0 0 0-1.15.872l.212 3.338-.466-.179a.548.548 0 0 0-.746.544l.206 3.577a.87.87 0 0 0 .497.739l3.092 1.47a.568.568 0 0 0 .813-.53l-.035-1.123L9.49 16.76a.86.86 0 0 0 .845-.038.85.85 0 0 0 .402-.748l-.03-1.265a523 523 0 0 0 1.971 1.04c.642.334 1.102 0 1.102 0l.053-.035 2.549-1.646s.456-.277.456-.994c0-.614.158-6.326.16-6.426.006-.398.152-2.183-2.396-2.86m-4.455 12.2a.26.26 0 0 1-.126.234.26.26 0 0 1-.263.012l-2.254-1.15-.058-1.88a1.04 1.04 0 0 0-.668-.941l-2.007-.77-.231-3.61V7.88a.26.26 0 0 1 .105-.236.26.26 0 0 1 .253-.038l4.416 1.626a1.06 1.06 0 0 1 .696.976zm.494-4.038L10.6 10.193a1.65 1.65 0 0 0-1.083-1.515L9.11 8.528 8.828 4.063a332 332 0 0 0 3.563 1.116s1.776.428 1.776 2.53c0 1.282.048 4.497.07 5.95a369 369 0 0 0-3.597-1.708" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const PlatformSignetIcon = /* @__PURE__ */ Object.assign(
  PlatformSignetIconComponent,
  { displayName: 'PlatformSignetIcon' },
);
